<template>
  <div class="relative py-24 sm:py-32 min-h-fit ">
    <!-- Background image  with top and bottom edges fading out -->
    <!-- <div class="absolute inset-0">
      <img
        src="@/assets/images/landing/horizontal-smoke-hires.webp"
        alt="Background"
        class="w-full h-full object-cover fade-out-top-bottom"
      >
    </div> -->
    <UiContainer>
      <div
        id="how-it-works"
        class="max-w-2xl mx-auto text-center flex flex-col justify-center items-center"
      >
        <UiTitle
          animation="fadeIn"
          :code="t('home.howItWorks.tag')"
        >
          {{ t('home.howItWorks.title') }}
        </UiTitle>
      </div>
      <div
        class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20
        lg:mx-0 lg:max-w-none lg:grid-cols-3"
      >
        <article
          v-for="howItWork in howItWorks"
          :key="howItWork.id"
          class="flex flex-col items-start justify-start"
        >
          <div class="relative w-full">
            <img
              :src="howItWork.imageUrl"
              alt=""
              class="aspect-square w-full rounded-2xl bg-gray-100
              object-cover sm:aspect-2/1 lg:aspect-3/2"
            >
            <div class="absolute inset-0 rounded-2xl ring-1 ring-gray-900/10 ring-inset" />
          </div>
          <div class="max-w-xl">
            <div class="group relative">
              <UiTitle
                type="h3"
                size="xl"
                align="left"
                color="gray"
                class="mt-8"
              >
                {{ howItWork.title }}
              </UiTitle>

              <UiParagraph
                size="lg"
                align="left"
                color="gray"
                class="mt-8"
              >
                {{ howItWork.description }}
              </UiParagraph>
            </div>
          </div>
        </article>
      </div>
    </UiContainer>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import choose from '@/assets/images/landing/howItWorks/goblin-choose.webp';
import vibes from '@/assets/images/landing/howItWorks/goblin-vibes.webp';
import success from '@/assets/images/landing/howItWorks/goblin-success.webp';

const { t } = useI18n();

// Computed
const howItWorks = computed(() => [
  {
    id: 1,
    title: t('home.howItWorks.title1'),
    imageUrl: choose,
    description:
      t('home.howItWorks.description1'),
  },
  {
    id: 2,
    title: t('home.howItWorks.title2'),
    imageUrl: vibes,
    description:
      t('home.howItWorks.description2'),
  },
  {
    id: 3,
    title: t('home.howItWorks.title3'),
    imageUrl: success,
    description:
      t('home.howItWorks.description3'),
  },
]);
</script>
